import React, { useState, useEffect, useRef } from "react";
import WidgetHeader from "../../../../components/Widget/Header";
import { FormattedDate, FormattedTime } from "react-intl";

const MyOrderWidget = ({ widget }) => {
  const mounted = useRef(false);

  const [orders, setOrders] = useState([]);
  const [title, setTitle] = useState("");
  const [sortBy, setSortBy] = useState(
    localStorage.getItem("MyOrdersSortBy") ?? "deadline"
  );

  useEffect(() => {
    mounted.current = true;
    fetch(`coordinatordashboard/My_Orders?sortBy=${sortBy}`)
      .then((response) => response.json())
      .then((data) => {
        if (mounted.current) {
          setOrders(data.data.orders);
        }
      });

    setTitle(widget.widgetId.replace(/_/g, " "));

    return () => {
      mounted.current = false;
    };
  }, [sortBy]);

  const onSortChange = (event) => {
    const {
      target: { value: sortBy },
    } = event;
    setSortBy(sortBy);
    localStorage.setItem("MyOrdersSortBy", sortBy);
  };

  const orderDetails = (uid) => {
    reactHistory.push(`/orders/${uid}`);
  };

  const getDeadline = (order) => {
    const value = new Date(order["deadline"] * 1000);
    return (
      <div>
        <span className="mr-1">
          <FormattedDate value={value} />
        </span>
        <span>
          <FormattedTime value={value} />
        </span>
      </div>
    );
  };

  const getDeadlineStatus = (order) => {
    const diff = order["deadline"] - Math.floor(Date.now() / 1000);
    if (diff > 86400) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-green-500"
          title="Deadline is not within the next 24 hours"
        ></i>
      );
    } else if (diff > 0) {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-yellow-500"
          title="Deadline is close!"
        ></i>
      );
    } else {
      return (
        <i
          className="block rounded-full w-2 h-2 bg-red-600"
          title="Deadline has passed"
        ></i>
      );
    }
  };

  const widget_id = `ID_${widget.widgetId}`;
  return (
    <div
      className="bg-white border shadow rounded border-gray-400"
      id={widget_id}
    >
      <WidgetHeader widget={widget} widgetTitle={title} />
      <div className="border-b py-2 px-3 flex justify-between items-center text-opacity-50 hover:text-opacity-100">
        <div className="space-x-1">
          <span>Sort by</span>
          <select onChange={(e) => onSortChange(e)} value={sortBy}>
            <option value="deadline">Deadline</option>
            <option value="created">Created Date</option>
          </select>
        </div>
        <div className="text-xs flex items-center space-x-1">
          <div className="inline-block w-4 h-4 rounded bg-yellow-200"></div>
          <span className="text-gray-500">= Direct Handover</span>
        </div>
      </div>

      <div className="w-full text-xs">
        {orders.map((order) => (
          <div
            className={`hover:bg-gray-200 flex border-b ${
              order["highlight"] == "1" ?? false ? "bg-yellow-100" : ""
            }`}
            onClick={() => orderDetails(order["uid"])}
            title={order["comments"]}
          >
            <div className="shrink-0 px-4 py-2 w-16">
              {order["uid"]}
            </div>
            {order["deal_id"] &&
              <div className="hover:text-primary shrink-0 px-4 py-2 w-16">
                <a
                  href={`https://my.arnsbogroup.com/crm/deal/details/${order["deal_id"]}/`}
                  target="_blank"
                  onClick={(e) => e.stopPropagation()}
                  className="mr-1"
                >
                  D{order["deal_id"]}
                </a>
              </div>
            }
            <div className="grow px-4 py-2 cursor-pointer hover:text-primary truncate">
              {order["name"]}
            </div>
            <div className="shrink-0 px-4 py-2 flex justify-between items-center space-x-4">
              <span>{getDeadline(order)}</span>
              <span className="w-1 inline-block ml-2 mr-1">
                {order["comments"] && (
                  <i className="text-yellow-500 fa fa-info"></i>
                )}
              </span>
              <span className="text-xs w-2 inline-block mr-1">
                {getDeadlineStatus(order)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyOrderWidget;
